import * as Y from 'yjs';

function fragmentHasText(node: Y.XmlFragment | Y.XmlElement): boolean {
  return node.toArray().some((child) => {
    if (child instanceof Y.XmlText) {
      return child
        .toDelta()
        .some((op: { insert?: unknown }) => typeof op.insert === 'string' && op.insert.trim() !== '');
    }
    return child instanceof Y.XmlElement && fragmentHasText(child);
  });
}

export function hasFragmentText(doc: Y.Doc | null, fragment: string): boolean {
  return doc !== null && fragmentHasText(doc.getXmlFragment(fragment));
}

export function hasBodyText(doc: Y.Doc | null): boolean {
  return hasFragmentText(doc, 'prosemirror');
}
